import { useState, useEffect, useRef } from "react";
import styles from "./navbar.module.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { CiHeart } from "react-icons/ci";
import { PiHandbag } from "react-icons/pi";
import { PiUser } from "react-icons/pi";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import { navItems } from "../../../constants/nav-links";
import { useGetCart } from "../../../queries/useCartQuery";
import authService from "../../../services/authService";
import toast from "react-hot-toast";
import { Image } from "../../shared/index";
import { useGetWishLists } from "../../../queries/useWishListQuery";
import GlobalProductsSearch from "../../GlobalSearch/GlobalProductsSearch";
import { useHomeQuery } from "../../../queries/useHomeQuery";
const Navbar = () => {
  const searchRef = useRef(null);
  const { data } = useHomeQuery();
  const categories = data?.categories || [];
  const { data: wishListItems = [] } = useGetWishLists({
    keepPreviousData: true,
  });
const visibleWishlistCount =
  wishListItems?.filter(
    (item) => item?.product?.qty > 0
  )?.length || 0;
  const { data: cartData = [] } = useGetCart({
    keepPreviousData: true,
  });
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [user, setUser] = useState(authService.getCurrentUser());
  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);
  const navigate = useNavigate();
  useEffect(() => {
    const syncAuth = () => {
      setUser(authService.getCurrentUser());
    };
    syncAuth();
    window.addEventListener("storage", syncAuth);
    window.addEventListener("focus", syncAuth);
    return () => {
      window.removeEventListener("storage", syncAuth);
      window.removeEventListener("focus", syncAuth);
    };
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && menuOpen) {
        closeMenu();
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [menuOpen]);
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setSearchOpen(false);
      }
    };
    if (searchOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchOpen]);


  const handleLogout = async () => {
    try {
      await authService.logout();
      setUser(null);
      toast.success("Logged out successfully");
      navigate("/", { replace: true });
      closeMenu();
    } catch (error) {
      toast.error("Logout failed. Please try again.");
    }
  };
  const isAuth = !!user;
  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.navbar__container}>
          <Link to="/" className={styles.navbar__logo}>
            <Image
              src="/Pharmacy_logo_1.svg"
              alt="Anuradha-logo"
              className={styles.anuradha__logo}
            /> 
          </Link>
          <div className={styles.navbar__search}>
            <GlobalProductsSearch onClose={() => setSearchOpen(false)} categories={categories} />
          </div>
          <ul className={styles.navbar__nav}>
            {navItems?.map((item) => (
              <li key={item?.to}>
                <NavLink
                  to={item?.to}
                  end={item?.end}
                  className={({ isActive }) =>
                    isActive
                      ? `${styles.navbar__link} ${styles.navbar__link__active}`
                      : styles.navbar__link
                  }
                >
                  {item?.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className={styles.navbar__actions}>

            {/* Search Icon */}

            {/* <div className={styles.navbar__search}>
            <GlobalProductsSearch onClose={() => setSearchOpen(false)}/>
          </div> */}
            {/* Wishlist */}
            {/* <Link to="/profile/wishlist">
              <button className={styles.navbar__icon_btn}>
                <CiHeart size={22} />
              {visibleWishlistCount > 0 && (
  <span className={styles.navbar__badge}>
    {visibleWishlistCount}
  </span>
)}
              </button>
            </Link> */}

            {/* Cart */}
            <Link to="/cart">
              <button className={styles.navbar__icon_btn}>
                <PiHandbag size={22} />
               <span className={styles.navbar__badge}>
  {isAuth ? cartData.length : 0}
</span>
              </button>
            </Link>

            {/* Profile */}
           <Link to={isAuth ? "/profile/order" : "/login"}>
  <button className={styles.navbar__icon_btn}>
    <PiUser size={22} />
  </button>
</Link>

          </div>
          <button className={styles.navbar__menu_btn} onClick={toggleMenu}>
            {menuOpen ? <HiX size={28} /> : <HiMenuAlt3 size={28} />}
          </button>
        </div>
        {searchOpen && (
          <div className={styles.navbar__search_container}>
            <div ref={searchRef} className={styles.navbar__search_form}>
              <GlobalProductsSearch onClose={() => setSearchOpen(false)} />
            </div>
          </div>
        )}
      </nav>
      {menuOpen && (
        <div className={styles.navbar__overlay} onClick={closeMenu} />
      )}
      <div
        className={`${styles.navbar__mobile_menu} ${menuOpen ? styles.navbar__mobile_menu__open : ""
          }`}
      >
        <div ref={searchRef} className={styles.navbar__mobile_search}>
          <GlobalProductsSearch onClose={closeMenu} categories={categories} />
        </div>
        <ul className={styles.navbar__mobile_nav}>
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  isActive
                    ? `${styles.navbar__mobile_link} ${styles.navbar__mobile_link__active}`
                    : styles.navbar__mobile_link
                }
                onClick={closeMenu}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <div className={styles.navbar__mobile_actions}>
          {/* <Link
            to="/profile/wishlist"
            className={styles.navbar__mobile_action_btn}
            onClick={closeMenu}
          >
            <CiHeart size={22} />
            <span>Wishlist</span>
          </Link> */}
          <Link
            to="/cart"
            className={styles.navbar__mobile_action_btn}
            onClick={closeMenu}
          >
            <PiHandbag size={22} />
          <span>Cart ({isAuth ? cartData?.length || 0 : 0})</span>
          </Link>
          {isAuth ? (
            <>
             <Link
  to="/profile/order"
  className={styles.navbar__mobile_action_btn}
  onClick={closeMenu}
>
  <PiUser size={22} />
  <span>Orders</span>
</Link>
              <button
                className={styles.navbar__mobile_action_btn}
                onClick={handleLogout}
              >
                Logout
              </button>
            </>
          ) : (
            <Link
              to="/login"
              className={styles.navbar__mobile_action_btn}
              onClick={closeMenu}
            >
              <PiUser size={22} />
              <span>Login</span>
            </Link>
          )}
        </div>
      </div>
    </>
  );
};
export default Navbar;